__webpack_require__.p = "https://media-assets.swiggy.com/rewards/_next/";